<template>
  <CollapsibleSection title="Financement" icon="fas fa-euro-sign" context="quote" storage-key="financement-info" :bare="bare">
    <DetailItem label="Financement">
      <select
        v-if="isEditing"
        v-model="editedQuote.financement"
        class="form-control"
      >
        <option value="">Non renseigné</option>
        <option value="OPCO">OPCO</option>
        <option value="FIFPL">FIFPL</option>
        <option value="Financé par l'entreprise">Financé par l'entreprise</option>
        <option value="France Travail">France Travail</option>
        <option value="Financé moi-même">Financé moi-même</option>
        <option value="CPF">CPF</option>
        <option value="Ne sais pas">Ne sais pas</option>
      </select>
      <template v-else>
        <span v-if="!isMissing(quote.financement)">{{ quote.financement }}</span>
        <DetailEmpty v-else />
      </template>
    </DetailItem>
    <template #footer>
      <slot name="footer" />
    </template>
  </CollapsibleSection>
</template>

<script setup>
import { CollapsibleSection, DetailItem, DetailEmpty } from '../data'

defineProps({
  /** Rend la section sans carte ni en-tête, pour l'imbriquer dans un bloc regroupé. */
  bare: {
    type: Boolean,
    default: false
  },
  quote: {
    type: Object,
    required: true
  },
  isEditing: {
    type: Boolean,
    default: false
  },
  editedQuote: {
    type: Object,
    default: () => ({})
  }
})

const isMissing = (value) => {
  return !value || value === '' || value === null || value === undefined
}
</script>
